import constants from 'domain/constants';
import { useParams } from 'react-router';

function ViewImage(props: { filenet?: string }) {
  const { filenet } = useParams<{ filenet: string }>();

  return (
    <div className='embed-responsive embed-responsive-16by9'>
      <iframe
        {...({
          authsrc: encodeURI(
            `${constants.API_BASE}/attachments?filenetId=${
              props.filenet || filenet
            }`
          ),
          is: 'auth-embed',
          class: 'embed-responsive-item',
        } as Record<string, unknown>)}
        style={{ resize: 'both' }}
      />
    </div>
  );
}

export default ViewImage;
